module.exports = __webpack_public_path__ + "media/images/social-linkedin-3b7e2e38fa704f36cd5e08167a5eab21.svg";